module.exports = __webpack_public_path__ + "static/media/path05.03687918.png";